import React from "react";

interface CreateComponentWrapper {
  children: React.ReactNode;
  componentType: React.ElementType;
}

export const PillarTableComponentWrapper = ({
  children,
  componentType,
}: CreateComponentWrapper) => {
  const componentWrapper = React.Children.toArray(children).find(
    (child): child is React.ReactElement =>
      React.isValidElement(child) && child.type === componentType,
  );

  if (!componentWrapper) {
    return <></>;
  }

  return componentWrapper;
};

export const createComponentWrapper = (
  componentType: React.ElementType,
  children: React.ReactNode,
) => {
  const WrapperComponent = () => {
    const result = PillarTableComponentWrapper({ children, componentType });
    return result;
  };

  return WrapperComponent ?? <></>;
};
